const getStellarConnectEndpoints = builder => ({
  fetchStellarConnectToken: builder.mutation({
    // TODO: change path once we rename it on api side
    query: () => '/saas/token',
  }),
})

export default getStellarConnectEndpoints
